import React from 'react';
const Redirecting = () => {
    return (
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-12">
            <div className="nothing-inner">
              <div className="nothing-icon"><i className="fal fa-spinner fa-spin"></i></div>
              <div className="nothing-content">
                <div className="nothing-text">Redirecting...</div>
                <div className="nothing-sub-text">Please wait! We are redirecting you to dashboard.</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
};
export default Redirecting;